import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

interface InitialState {
  status: ReduxStateType;
  data: {
    public: boolean;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {
    public: false,
  },
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginStart: (state, action?: PayloadAction<string>) => {
      state.status = ReduxStateType.LOADING;
    },
    loginSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    loginFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetLogin: () => {
      return { ...initialState };
    },
  },
});

export const { loginStart, loginSuccess, loginFailed, resetLogin } =
  loginSlice.actions;

const loginPersistConfig = {
  key: "login",
  storage,
  blacklist: [], // Nếu không cần blacklist, có thể bỏ qua
};

const loginPersistReducer = persistReducer(
  loginPersistConfig,
  loginSlice.reducer
);

export default loginPersistReducer;
